import Cookies from 'cookie-universal'
import type { CartProduct, Product } from '@mc/api'
import { AUTH_TYPE } from '@mc/constants'
import { getGDPRCheckboxValue } from '@mc/gdpr'
import {
  getDefaultSubscriptionPlanPropertiesAsync,
  getLTVPriceValueFromProduct,
} from '@mc/products'
import {
  trackGoldStandardEvent,
  PageSource,
  CartEvents,
  PageLoadEvents,
} from '@mc/track-event'
import type {
  CartEmailCaptureEventProps,
  CartEmailCaptureOnHeroEventProps,
} from '../../types/CartEmailCaptureEventProps'

export const trackCartEmailCaptured = ({
  location = 'falcon_cart',
  type = AUTH_TYPE.EMAIL,
  email,
  pageSource = PageLoadEvents.PLANS,
  captureMethod = CartEvents.EMAIL_GATHER.USER_ADDED,
  isGift = false,
  product,
  ...freeTrial
}: CartEmailCaptureEventProps) => {
  const revenue = product ? getLTVPriceValueFromProduct(isGift, product) : null

  const eventDetails = {
    ...baseProps(product),
    location,
    type,
    email,
    page_source: pageSource,
    email_capture_method: captureMethod,
    ...(revenue && { revenue }),
    ...freeTrial,
  }

  trackGoldStandardEvent(
    CartEvents.EVENTS.CART_EMAIL_CAPTURED_GOLD_STANDARD,
    eventDetails,
  )
}

const baseProps = (product?: CartProduct | Product) => {
  const cookies = Cookies()
  const allCmPagesViewed = cookies.get('all_cm_pages_viewed')
  const lastCmPageViewed = cookies.get('last_cm_page')

  const productProps = product
    ? {
        content_type: 'product',
        product_id: `${product.id}`,
      }
    : {}

  return {
    ...productProps,
    currency: product?.currency || 'USD',
    quantity: 1,
    product: 'core', // TODO https://masterclass-dev.atlassian.net/browse/PEN-4307
    gdpr_opt_in: !!getGDPRCheckboxValue(),
    ...(allCmPagesViewed && { all_cm_pages_viewed: allCmPagesViewed }),
    ...(lastCmPageViewed && { last_cm_page_viewed: lastCmPageViewed }),
  }
}

export const trackCartEmailCapturedOnHero = async ({
  location = 'hero',
  type = AUTH_TYPE.EMAIL,
  email,
  pageSource = PageSource.HOMEPAGE,
  captureMethod = CartEvents.EMAIL_GATHER.USER_ADDED,
  nextCaptureMethod,
  ...freeTrial
}: CartEmailCaptureOnHeroEventProps) => {
  const product = (await getDefaultSubscriptionPlanPropertiesAsync()) || {}

  const eventDetails = {
    ...baseProps(product),
    location,
    type,
    revenue: getLTVPriceValueFromProduct(false, product),
    ...(email && { email }),
    page_source: pageSource,
    email_capture_method: captureMethod,
    ...freeTrial,
  }

  trackGoldStandardEvent(
    CartEvents.EVENTS.CART_EMAIL_CAPTURED_GOLD_STANDARD,
    eventDetails,
  )
}
